module.exports = __webpack_public_path__ + "./assets/img/portfolio_1.2d8ea039.jpg";